export const Watermark = () => (
  <div
    aria-hidden="true"
    className="pointer-events-none fixed inset-0 z-0 flex items-center justify-center opacity-[0.07] mix-blend-multiply"
  >
    <img
      src="/assets/logo.jpg"
      alt=""
      className="w-[130vmin] max-w-none rotate-[-6deg]"
    />
  </div>
);
